import styled, { keyframes } from 'styled-components';

const fadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

const fadeOut = keyframes`
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
`;

export const CarouselContainer = styled.div`
  overflow: hidden;
  width: 100%;
  max-width: 600px; /* Defina a largura máxima conforme necessário */
  margin: 0 auto;
`;

export const CarouselSlide = styled.div`
  display: ${(props) => (props.active ? 'block' : 'none')};
  transition: opacity 1s ease-in-out;
`;

export const Image = styled.img`
  width: 100%;
  height: auto;
  animation: ${(props) => (props.active ? fadeIn : fadeOut)} 0s ease-in-out;
`;
